module.exports = __webpack_public_path__ + "static/media/01.a8d81638.mp3";